import { useState } from "react";

export default function DynamicReportTable({
  data = [],
  filters = {},
  applyFilters,
  hotelName = "",
}) {
  const FILTERABLE_COLUMNS = [
    "Cancellation_Status",
    "Payement_Status",
    "Payment_Method",
  ];

  const [openFilter, setOpenFilter] = useState(null);

  function updateFilter(column, value) {
    applyFilters({
      ...filters,
      [column]: value,
    });

    setOpenFilter(null);
  }

  const filteredData = data.filter((row) => {
    return Object.entries(filters).every(([column, value]) => {
      if (!value || value === "all") return true;

      return String(row[column]) === String(value);
    });
  });

  function getDistinctValues(column) {
    return [...new Set(data.map((row) => row[column]))].filter(Boolean);
  }

  if (!data || data.length === 0) {
    return (
      <div className="text-center py-5 text-muted">
        No report data available
      </div>
    );
  }

  const columns = Object.keys(data[0]);

  function formatColumnName(column) {
    return column
      .replace(/([A-Z])/g, " $1")
      .replace(/_/g, " ")
      .replace(/^./, (str) => str.toUpperCase());
  }

  return (
    <div
      className="table-responsive"
      style={{
        overflowY: "visible",
      }}
    >
      {hotelName && (
        <div
          className="text-center mb-3"
          style={{
            fontSize: "24px",
            fontWeight: "600",
          }}
        >
          {hotelName}
        </div>
      )}
      <table className="table table-striped table-hover align-middle mb-0">
        <thead className="table-dark">
          <tr>
            {columns.map((column) => (
              <th
                key={column}
                style={{
                  position: "relative",
                }}
              >
                {FILTERABLE_COLUMNS.includes(column) ? (
                  <>
                    <div
                      onClick={() =>
                        setOpenFilter(openFilter === column ? null : column)
                      }
                      style={{
                        cursor: "pointer",
                        userSelect: "none",
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                    >
                      <span>{formatColumnName(column)}</span>

                      <span>
                        {filters[column] && filters[column] !== "all"
                          ? "🔽"
                          : "▼"}
                      </span>
                    </div>

                    {openFilter === column && (
                      <div
                        className="card shadow"
                        style={{
                          position: "absolute",
                          top: "100%",
                          left: 0,
                          zIndex: 9999,
                          minWidth: "180px",
                          color: "#000",
                          background: "#fff",
                        }}
                      >
                        <div
                          className="p-2 border-bottom"
                          style={{
                            cursor: "pointer",
                          }}
                          onClick={() => updateFilter(column, "all")}
                        >
                          All
                        </div>

                        {getDistinctValues(column).map((value) => (
                          <div
                            key={value}
                            className="p-2 border-bottom"
                            style={{
                              cursor: "pointer",
                            }}
                            onClick={() => updateFilter(column, value)}
                          >
                            {value}
                          </div>
                        ))}
                      </div>
                    )}
                  </>
                ) : (
                  formatColumnName(column)
                )}
              </th>
            ))}
          </tr>
        </thead>

        <tbody>
          {filteredData.length > 0 ? (
            filteredData.map((row, rowIndex) => (
              <tr key={rowIndex}>
                {columns.map((column) => (
                  <td key={`${rowIndex}-${column}`}>{row[column] ?? "-"}</td>
                ))}
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan={columns.length} className="text-center py-4">
                No matching records found
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
}
